$(function () {

    /*
     * Make sticky tabs scroll to top after getting activated
     */
    $("a[data-toggle=\"tab\"]").on("shown.bs.tab", function (event) {
        if ($(event.target).closest(".nav.nav-tabs.sticky").hasClass("stuck")) {
            $("html,body").animate({
                scrollTop: $("#tab-scroll-anchor").offset().top
            }, "1000");
        }
    });

});
